import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./SelectValue.styled";
import { Typography } from "../../Typography";

function SelectValue() {
  const { tokens } = useDesignTokens();
  const { select } = tokens;

  return (
    <Typography
      variant={select.button.text.typography.variant}
      fontFamily={select.button.text.typography.fontFamily}
      noWrap
    >
      <S.SelectValue>{({ selectedText }) => selectedText}</S.SelectValue>
    </Typography>
  );
}

export default SelectValue;
